import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import { Badge } from '../ui/badge';

/**
 * Post-merge success view — replaces the comparison grid once the API call
 * succeeds. Shows what fields were filled from duplicates and any linked
 * records (claims, EVV visits, timesheets, …) that were reassigned.
 */
const MergeSuccess = ({ result }) => (
  <div className="text-center py-8" data-testid="merge-success">
    <CheckCircle size={56} className="mx-auto mb-4 text-emerald-500" weight="fill" />
    <h3 className="text-lg font-semibold text-slate-900 mb-2">Merge Complete</h3>
    <p className="text-slate-500 mb-4">{result.message}</p>

    {result.fields_filled?.length > 0 && (
      <div className="bg-emerald-50 rounded-lg p-4 inline-block mx-auto text-left">
        <p className="text-sm font-medium text-emerald-700 mb-2">Fields filled from duplicates:</p>
        <div className="flex flex-wrap gap-1.5">
          {result.fields_filled.map((f) => (
            <Badge key={f} variant="outline" className="bg-white text-emerald-700 text-xs">
              {f}
            </Badge>
          ))}
        </div>
      </div>
    )}

    {Object.keys(result.reassigned_records || {}).length > 0 && (
      <div className="bg-blue-50 rounded-lg p-4 inline-block mx-auto text-left mt-3">
        <p className="text-sm font-medium text-blue-700 mb-2">Reassigned linked records:</p>
        {Object.entries(result.reassigned_records).map(([coll, count]) => (
          <p key={coll} className="text-sm text-blue-600">
            {coll}: {count} record(s)
          </p>
        ))}
      </div>
    )}
  </div>
);

export default MergeSuccess;
